<template>
    <LayoutPage
        imageName="map-bg.jpg"
        :title="title">
         <template v-slot:banner>
            <BannerSmallerWithSearchAndButton
                :imageName="$t('UI.banners.smallerBannerImage')"
                :title="title"
                :description="description"
            />
        </template>
        <template v-slot:content>
            <div class="box box--space-vertical">
                <div class="mm-section">
                    <div class="mm-section-content">
                        <div class="container-fluid w-100">
                            <div class="row">
                                <div class="col-12">
                                    <div class="box box--space-vertical">
                                        <router-link :to="localeRoute('news')"
                                            class="mm-link mm-link--icon-left-space-s">
                                            <i class="icon icon-arrow-left"></i>Back to All news
                                        </router-link>
                                    </div>
                                </div>
                            </div>

                            <slot name="content"></slot>

                            <div v-if="postsFixed">
                                <PostPreview
                                    v-for="item in postsFixed"
                                    :key="item.id"
                                    :id="item.seo_id"
                                    :title="item.title"
                                    :previewText="item.preview_text"
                                    :attachments="item.attachments"
                                    :to="localeRoute({name: 'news_id', params: { id: item.seo_id}})"
                                />
                            </div>

                            <div v-if="postsTag" class="box box--space-bottom">
                                <div v-if="postsRequestState === 'success'">
                                    <PostPreview
                                        v-for="item in posts"
                                        :key="item.id"
                                        :id="item.seo_id"
                                        :title="item.title"
                                        :previewText="item.preview_text"
                                        :attachments="item.attachments"
                                        :to="localeRoute({name: 'news_id', params: { id: item.seo_id}})"
                                    />
                                </div>
                                <div v-else-if="postsRequestState === 'request'">
                                    <app-spinner />
                                </div>
                                <div v-else>
                                    <p class="text text--error">
                                        Doslo k chybe. Zkontrolujte prosim formular a odeslete ho znovu
                                    </p>
                                </div>
                            </div>

                            <div class="button-group">
                                <button
                                    v-if="pageId > 0"
                                    @click="moveBack"
                                    class="button button button--wider-border button--small-text transparent--button button--l button--uppercase button--float-left">
                                    Nacist novejsi
                                </button>
                                <button
                                    v-if="postsRequestState === 'success' && posts.length > 2"
                                    @click="moveNext"
                                    class="button button button--wider-border button--small-text transparent--button button--l button--uppercase button--float-left">
                                    Nacist starsi
                                </button>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </template>
    </LayoutPage>
</template>

<script>
import { setPageTitle, setMeta, getPageTitle, getPageMetaDescription } from '@/utils/meta'
import LayoutPage from '@/components/layouts/Page';
import webCMS from '@/services/WebCMS';
import PostPreview from '@/components/PostPreview';
import BannerSmallerWithSearchAndButton from '@/components/ui/Banner/SmallerWithSearchAndButton';

export default {
    components: {
        LayoutPage,
        PostPreview,
        BannerSmallerWithSearchAndButton
    },
    props: {
        title: {
            type: String,
            required: true
        },
        description: {
            type: String
        },
        postsFixedTag: {
            type: String,
            default: null
        },
        postsTag: {
            type: String,
            default: null
        },
        limit: {
            type: Number,
            default: 2
        },
        routeName: {
            type: String,
            required: true
        }
    },
    created: function() {
        setPageTitle(getPageTitle(this.$route));
        setMeta("description", getPageMetaDescription(this.$route));

        if (this.postsFixedTag !== null) {
            this.loadFixed();
        }

        if (this.postsTag !== null) {
            this.loadData(this.limit, (this.pageId * this.limit));
        }
    },
    watch: {
        '$route.query.page': function (value) {
            if (this.postsTag !== null) {
                if (value) {
                    this.loadData(this.limit, value * this.limit);
                } else {
                    this.loadData(this.limit, 0);
                }
            }
        }
    },
    data() {
        return {
            posts: null,
            postsFixed: null,
            postsRequestState: null,
            postsFixedRequestState: null
        }
    },
    computed: {
        pageId() {
            if (this.$route.query && this.$route.query.page) {
                return this.$route.query.page;
            } else {
                return 0;
            }
        }
    },
    methods: {
        moveBack() {
            let query = {};
            if (this.pageId > 1) {
                query = {...this.$route.query, 'page': this.pageId - 1};
            }
            this.$router.push(this.localeRoute({name: this.routeName, query}));
        },
        moveNext() {
            const query = {...this.$route.query, 'page': this.pageId + 1};
            this.$router.push(this.localeRoute({name: this.routeName, query}));
        },
        loadFixed() {
            this.postsFixedRequestState = "request";
            webCMS.getNews(this.axios, {tag: this.postsFixedTag})
                .then(res => {
                    this.postsFixedRequestState = "success";
                    this.postsFixed = res;
                })
                .catch(error => {
                    this.postsFixedRequestState = "failure";
                    console.log(error);
                });
        },
        loadData(limit, offset) {
            this.postsRequestState = "request";
            webCMS.getNews(this.axios, {tag: this.postsTag, limit, offset})
                .then(res => {
                    this.postsRequestState = "success";
                    this.posts = res;
                })
                .catch(error => {
                    this.postsRequestState = "failure";
                    console.log(error);
                });
        }
    }
}
</script>
